var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedEnvelopeSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.36038V12C0.5 12.8284 1.17157 13.5 2 13.5H14C14.8284 13.5 15.5 12.8284 15.5 12V4.36036L8.86018 9.00823C8.3437 9.36977 7.65627 9.36977 7.13979 9.00824L0.5 4.36038Z",
    fill: "#287C87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3116 3.2716C15.0554 2.81136 14.5641 2.5 14 2.5H2C1.43591 2.5 0.94455 2.81137 0.688409 3.27161L7.71325 8.189C7.88541 8.30951 8.11455 8.30951 8.28671 8.189L15.3116 3.2716Z",
    fill: "#287C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEnvelopeSubtitle);
export default __webpack_public_path__ + "static/media/closed-envelope-subtitle.a6903e2112fe0ef0bff294b420053484.svg";
export { ForwardRef as ReactComponent };